/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"

import Header from "./header"
import "./layout.css"

const Layout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  useEffect(() => {
    const closeOnEscape = event => {
      if (event.key === "Escape") setIsMenuOpen(false)
    }

    window.addEventListener("keydown", closeOnEscape)
    return () => window.removeEventListener("keydown", closeOnEscape)
  }, [])

  return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <button
        type="button"
        className={`burger-menu ${isMenuOpen ? 'open' : ''}`}
        onClick={toggleMenu}
        aria-expanded={isMenuOpen}
        aria-controls="mobile-navigation"
        aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
      >
        <div className="burger-bar"></div>
        <div className="burger-bar"></div>
        <div className="burger-bar"></div>
      </button>
      <div id="mobile-navigation" className={`fullscreen-menu ${isMenuOpen ? 'open' : ''}`}>
        <nav className="fullscreen-nav" aria-label="Mobile navigation">
          <Link 
            to="/" 
            className="nav-link"
            activeClassName="active"
            onClick={toggleMenu}
          >
            Home
          </Link>
          <Link 
            to="/countach" 
            className="nav-link"
            activeClassName="active"
            onClick={toggleMenu}
          >
            Countach
          </Link>
          <Link 
            to="/tristec-gto" 
            className="nav-link"
            activeClassName="active"
            onClick={toggleMenu}
          >
            GTO
          </Link>
          <Link
            to="/contact"
            className="nav-link"
            activeClassName="active"
            onClick={toggleMenu}
          >
            Contact
          </Link>
        </nav>
      </div>
      <nav aria-label="Primary navigation">
        <Link 
          to="/" 
          className="nav-link"
          activeClassName="active"
        >
          Home
        </Link>
        <Link 
          to="/countach" 
          className="nav-link"
          activeClassName="active"
        >
          Countach
        </Link>
        <Link 
          to="/tristec-gto" 
          className="nav-link"
          activeClassName="active"
        >
          GTO
        </Link>
        <Link
          to="/contact"
          className="nav-link"
          activeClassName="active"
        >
          Contact
        </Link>
      </nav>
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
        }}
      >
        <main>{children}</main>
      </div>
      <footer
        style={{
          marginTop: `2rem`,
          background: '#00B7EB',
          marginBottom: `1.45rem`,
          color: `white`,
          textAlign: 'center',
        }}
      >
        © {new Date().getFullYear()} Tristec Ltd
      </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
